// Chakra imports
import {
  Flex,
  Table,
  Button,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
  Stack,
  Box,
  useToast,
  FormControl,
  Select,
  InputGroup,
  InputRightElement,
  Input,
  Checkbox,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import LinkRow from "./LinkRow";
import React, { useEffect, useMemo, useRef, useState } from "react";
import useAxios from "axios-hooks";
import { checkLogin, logout, getToken } from "../../../utils/authentication";
import AddLinkDialog from "components/Link/AddLinkDialog";
import { TablePagination } from "@trendmicro/react-paginations";
import { initialFilter, API_ROUTES } from "utils/constant";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { ROOT_API } from "utils/constant";
import { axiosPost } from "utils/api";
import { SearchIcon } from "@chakra-ui/icons";
import SyncEmailModal from "./SyncEmailModal";

export const StatusBlock = {
  Blocked: "Blocked",
  UnBlock: "Unblocked",
};

export const StatusLimit = {
  Yes: "Yes",
  No: "No",
};

function SMTPServerDetail() {
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const xToken = getToken();
  // const [links, setLinks] = React.useState([]);
  const [blockedList, setBlockedList] = React.useState();
  const [filter, setFilter] = useState(initialFilter);
  const params = useParams();
  const { brand } = params || {};
  const [selectedRows, setSelectedRows] = useState([]);
  const toast = useToast();
  const [searchValue, setSearchValue] = useState("");
  const [registerFrom, setRegisterFrom] = useState("");
  const [isLimit, setIsLimit] = useState("");

  const {
    isOpen: isOpenSyncEmailModal,
    onOpen: onOpenSyncEmailModal,
    onClose: onCloseSyncEmailModal,
  } = useDisclosure();

  const handleSelectRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const [{ data: dataEmails }, refetch] = useAxios({
    url: ROOT_API + API_ROUTES.SMTP_SERVER + `/${brand}`,
  });

  const {
    isOpen: isAddLinkOpen,
    onOpen: onAddLinkOpen,
    onClose: onAddLinkClose,
  } = useDisclosure();

  const handleDeleteMutilEmail = async () => {
    if (window.confirm("Are you sure to delete for these emails")) {
      try {
        const dataPayload = {
          ids: selectedRows,
          brand,
        };
        const response = await axiosPost(
          ROOT_API + API_ROUTES.DELETE_MULTIPLE_EMAIL,
          dataPayload
        );
        if (response?.data?.code == 0) {
          toast({
            title: "Delete emails Backup Successfully",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          refetch();
        }
      } catch (error) {
        toast({
          title:
            error?.response?.data?.errors?.errors[0]?.msg ||
            error?.response?.data?.msg ||
            "Delete emails Backup Fail",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
  };
  // const handleSyncEmail = async () => {
  //   if (
  //     window.confirm(
  //       `Are you sure to sync email from ${
  //         ["8DAY", "2Q"].includes(dataEmails?.data?.brand) ? "888B" : "8DAY"
  //       } to ${dataEmails?.data?.brand}`
  //     )
  //   ) {
  //     try {
  //       const dataPayload = {
  //         brandFrom: ["8DAY", "2Q"].includes(dataEmails?.data?.brand)
  //           ? "888B"
  //           : "8DAY",
  //         brandTo: dataEmails?.data?.brand,
  //       };
  //       const response = await axiosPost(
  //         ROOT_API + API_ROUTES.SYNC_EMAIL,
  //         dataPayload
  //       );
  //       if (response?.data?.code == 0) {
  //         toast({
  //           title: "Sync emails Backup Successfully",
  //           status: "success",
  //           duration: 9000,
  //           isClosable: true,
  //         });
  //         refetch();
  //       }
  //     } catch (error) {
  //       toast({
  //         title:
  //           error?.response?.data?.errors?.errors[0]?.msg ||
  //           error?.response?.data?.msg ||
  //           "Sync emails Backup Fail",
  //         status: "error",
  //         duration: 9000,
  //         isClosable: true,
  //       });
  //     }
  //   }
  // };

  // useEffect(() => {
  //   setLinks(dataEmails?.data);
  // }, [dataEmails]);

  useEffect(() => {
    getBlockedListEmail();
  }, []);

  const getBlockedListEmail = async () => {
    try {
      const dataPayload = {
        brand,
      };
      const response = await axiosPost(
        ROOT_API + API_ROUTES.BLOCKED_LIST,
        dataPayload
      );
      if (response?.data?.code == 0) {
        setBlockedList(response?.data?.data);
      }
    } catch (error) {
      console.log(error?.message);
    }
  };

  const limitCount = useMemo(() => {
    return dataEmails?.data?.backupEmails?.filter((item) => !!item.isLimit)
      .length;
  }, [dataEmails]);

  const blockedCount = useMemo(() => {
    return dataEmails?.data?.backupEmails?.filter((item) => !!item.isBlocked)
      .length;
  }, [dataEmails]);

  const filteredProducts = useMemo(() => {
    return dataEmails?.data?.backupEmails?.filter((product) => {
      // const matchesSearch = product?.mailSentInDay === Number(searchValue);
      const matchesBlocked =
        registerFrom === "Blocked"
          ? product.isBlocked
          : registerFrom === "Unblocked"
          ? !product.isBlocked
          : true;
      const matchesLimit =
        isLimit === "Yes"
          ? product.isLimit
          : isLimit === "No"
          ? !product.isLimit
          : true;
      return matchesBlocked && matchesLimit;
    });
  }, [dataEmails?.data?.backupEmails, registerFrom, isLimit]);

  const handleSelectAll = () => {
    if (selectedRows?.length === dataEmails?.count) {
      setSelectedRows([]);

      return;
    }

    const emailIds = dataEmails?.data?.backupEmails?.map((item) => item?._id);

    setSelectedRows(emailIds);
  };

  return (
    <>
      <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
        <Card bg="#fff" overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
          <CardHeader p="6px 0px 22px 0px">
            <Flex justifyContent={"space-between"}>
              <Flex direction={"column"} flex={2}>
                <Flex>
                  <Text fontSize="xl" color={textColor} fontWeight="bold">
                    Backup email of {dataEmails?.data?.brand}
                  </Text>
                </Flex>
                <Flex mt={2} gap={5} mb={2}>
                  <Flex minW={"200px"}>
                    <Text fontSize="xl" color={textColor} fontWeight="bold">
                      Total: {dataEmails?.count}
                    </Text>
                  </Flex>
                  <Flex alignItems={"flex-end"} wrap={"wrap"}>
                    <Text fontSize="xl" color={textColor} fontWeight="bold">
                      Blocked:
                    </Text>
                    <Text
                      fontSize="md"
                      color={textColor}
                      wordBreak={"break-word"}
                    >
                      {JSON.stringify(blockedList)}
                    </Text>
                  </Flex>
                </Flex>
                <Flex gap={5}>
                  <Flex minW={"200px"}>
                    <Text fontSize="xl" color={textColor} fontWeight="bold">
                      Total limit: {limitCount}
                    </Text>
                  </Flex>
                  <Flex>
                    <Text fontSize="xl" color={textColor} fontWeight="bold">
                      Total blocked: {blockedCount}
                    </Text>
                  </Flex>
                </Flex>

                <Flex columnGap={6} my={3}>
                  <FormControl>
                    <Select
                      placeholder="Select Status Block"
                      onChange={(e) => setRegisterFrom(e.target.value)}
                      value={registerFrom || ""}
                    >
                      <option value={undefined} hidden></option>
                      {Object.keys(StatusBlock).map((item, index) => (
                        <option
                          key={item}
                          value={StatusBlock[item]}
                          // fontWeight={500}
                        >
                          {StatusBlock[item]}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl>
                    <Select
                      placeholder="Select Status Reach Limit"
                      onChange={(e) => setIsLimit(e.target.value)}
                      value={isLimit || ""}
                    >
                      <option value={undefined} hidden></option>
                      {Object.keys(StatusLimit).map((item, index) => (
                        <option
                          key={item}
                          value={StatusLimit[item]}
                          // fontWeight={500}
                        >
                          {StatusLimit[item]}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  {/* <FormControl>
                  <InputGroup>
                    <InputRightElement pointerEvents="none">
                      <SearchIcon color="gray.300" />
                    </InputRightElement>
                    <Input
                      type="text"
                      variant="outline"
                      placeholder="Search by email"
                      value={searchValue}
                      onChange={(event) => setSearchValue(event.target.value)}
                      // onKeyUp={(event) => {
                      //   if (event.key === "Enter" && event?.target?.value) {
                      //     const searchBtn = refSearchButton?.current;
                      //     if (searchBtn !== null) {
                      //       searchBtn.click();
                      //     }
                      //   }
                      // }}
                    />
                  </InputGroup>
                </FormControl> */}
                </Flex>
                <Flex justifyContent={"flex-end"} columnGap={3}>
                  {/* <Button
                  ref={refSearchButton}
                  disabled={!searchValue && !registerFrom}
                  colorScheme="blue"
                  onClick={() => {
                    setFilter({
                      ...filter,
                      searchKeyword: searchValue,
                      registerFrom,
                      pageIndex: 0,
                    });
                  }}
                >
                  Filter
                </Button> */}
                  <Button
                    onClick={() => {
                      setSearchValue("");
                      setFilter({
                        ...filter,
                        searchKeyword: "",
                        registerFrom: "",
                        pageIndex: 0,
                      });
                      setIsLimit("");
                      setRegisterFrom("");
                    }}
                  >
                    Reset
                  </Button>
                </Flex>
              </Flex>
              <Flex>
                <Button
                  colorScheme="blue"
                  onClick={onOpenSyncEmailModal}
                  mr={2}
                >
                  Sync email
                </Button>
                <Button
                  disabled={selectedRows?.length === 0}
                  onClick={handleDeleteMutilEmail}
                >
                  Delete emails
                </Button>
              </Flex>
            </Flex>
          </CardHeader>
          <AddLinkDialog
            isOpen={isAddLinkOpen}
            onOpen={onAddLinkOpen}
            onClose={onAddLinkClose}
            fetchData={refetch}
            // data={props}
          />
          <CardBody>
            <Stack overflow={"auto"}>
              <Table variant="simple" color={textColor}>
                <Thead>
                  <Tr my=".8rem" pl="0px" color="gray.400">
                    <Th borderColor={borderColor}>
                      <Checkbox
                        isChecked={selectedRows?.length === dataEmails?.count}
                        onChange={handleSelectAll}
                      />
                    </Th>
                    <Th pl="0px" borderColor={borderColor} color="gray.400">
                      ID
                    </Th>
                    <Th pl="0px" borderColor={borderColor} color="gray.400">
                      Email
                    </Th>
                    <Th borderColor={borderColor} color="gray.400">
                      Password
                    </Th>
                    <Th borderColor={borderColor} isTruncated color="gray.400">
                      Email send in day
                    </Th>
                    <Th borderColor={borderColor} isTruncated color="gray.400">
                      Reach the limit
                    </Th>
                    <Th borderColor={borderColor} isTruncated color="gray.400">
                      Google
                    </Th>
                    <Th borderColor={borderColor} isTruncated color="gray.400">
                      From store
                    </Th>
                    <Th borderColor={borderColor}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {filteredProducts?.map((row, index, arr) => {
                    return (
                      <LinkRow
                        smtpId={dataEmails?.data?._id}
                        _id={row._id}
                        logo={row.logo}
                        name={row._id}
                        url={row.authUserEmail}
                        loop={row.authUserPassword}
                        order={row.mailSentInDay}
                        status={row.isLimit}
                        timer={row.timer}
                        isLast={index === arr.length - 1 ? true : false}
                        key={index}
                        refetch={refetch}
                        row={row}
                        isSelected={selectedRows.includes(row._id)}
                        onSelect={handleSelectRow}
                      />
                    );
                  })}
                </Tbody>
              </Table>
              <Flex justifyContent={"flex-end"}>
                <TablePagination
                  type="full"
                  page={1}
                  pageLength={1000}
                  totalRecords={dataEmails?.data?.backupEmails?.length}
                  onPageChange={({ page, pageLength }) => {
                    setFilter({
                      ...filter,
                      pageSize: pageLength,
                      pageIndex: page - 1,
                    });
                  }}
                  prevPageRenderer={() => <i className="fa fa-angle-left" />}
                  nextPageRenderer={() => <i className="fa fa-angle-right" />}
                />
              </Flex>
            </Stack>
          </CardBody>
        </Card>
      </Flex>
      {isOpenSyncEmailModal && (
        <SyncEmailModal
          isOpen={isOpenSyncEmailModal}
          onOpen={onOpenSyncEmailModal}
          onClose={onCloseSyncEmailModal}
          fetchData={refetch}
          currentBrand={dataEmails?.data?.brand}
        />
      )}
    </>
  );
}

export default SMTPServerDetail;
